// 31f00f9403751c9634d984ded2c01f84f6e47943|name=QueryResultApiExportResultParams|schemaHash=7c210447a16be4966d41827400b9e313b701559b|kind=parser-js

import { setDefinedValue } from '@myre/common-primitives';

export function parseQueryResultApiExportResultParamsFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'customerId', _data.customerId);
  setDefinedValue(result, 'handleId', _data.handleId);
  setDefinedValue(result, 'format', _data.format);

  return result;
}

export function parseQueryResultApiExportResultParamsToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'customerId', _data.customerId);
  setDefinedValue(result, 'handleId', _data.handleId);
  setDefinedValue(result, 'format', _data.format);

  return result;
}
